import { Injectable } from "@angular/core";
import { Navigator } from "../../components/menu/navigator";
import { EventsService } from "../event/event.service";
import { ConfigService } from "../config/config.service";
import { OverlayService } from "../overlay/overlay.service";
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class NotificationHandlerService {
  private timeoutId: any;
  private initialTimeoutId: any;
  private initialTimeout = 50;
  private timeoutInterval = 1000;
  private eventQueue = [];
  private eventConfig = null;
  private eventHideTimeout = null;
  public recentEvent = null;
  public genericPopupShown = false;
  public marketingPopupShown = false;
  public genricEventTimeoutId: any;
  public genricEventTimeout = 1000;
  public isSplashScreenFinished$ = new BehaviorSubject<boolean>(false);
  private _isSplashScreenFinished = false;
  public isNotificationHalted$ = new BehaviorSubject<boolean>(false);
  private _isNotificationHalted = false;

  constructor(
    private eventsService: EventsService,
    public navigator: Navigator,
    private config: ConfigService,
    private overlay: OverlayService
  ) {
    this.initializeTimeoutInterval();
    this.getEventConfiguration();
    this.eventsService.subscribe("event:notifications:start", () => {
      if (!this.initialTimeoutId) {
        this.initialTimeoutId = setTimeout(() => {
          this.checkIfActiveAndDisplay();
        }, this.initialTimeout);
      }
    });
    this.eventsService.subscribe("event:notifications:forceStart", () => {
      this.initialTimeoutId = setTimeout(() => {
        this.checkIfActiveAndDisplay();
      }, this.initialTimeout);
    });
    this.eventsService.subscribe("event:notifications", (e) => {
      this.checkForPopupAndDisplay(e);
    });
    this.eventsService.subscribe("event:marketingpopup:active", (e) => {
      this.marketingPopupShown = true;
    });
    this.eventsService.subscribe("event:marketingpopup:inactive", (e) => {
      this.marketingPopupShown = false;
    });
  }
  checkForPopupAndDisplay(e) {
    if (this.marketingPopupShown) {
      this.clearGenericTimeout();
      this.genricEventTimeoutId = setTimeout(() => {
        this.checkForPopupAndDisplay(e);
      }, this.genricEventTimeout);
    } else {
      this.handleGenericPopups(e);
    }
  }
  checkIfActiveAndDisplay() {
    this.overlay.overlayInProgress = false;
    if (
      this.checkNoActiveComponents() &&
      !this.overlay.overlayInProgress &&
      (this.navigator.currentTab === "casino" || !this.navigator.currentTab) &&
      !this.genericPopupShown
      ) {
        this.clearTimeout();
        // const justSignedUp = sessionStorage.getItem('signed-up') === 'true';
        // if (justSignedUp) {
        //   return;
        // }
      this.eventsService.publish("event:notifications:safeStart");
    } else {
      this.clearTimeout();
      this.timeoutId = setTimeout(() => {
        this.checkIfActiveAndDisplay();
      }, this.timeoutInterval);
    }
  }
  clearTimeout() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  checkNoActiveComponents(): boolean {
    return this.navigator.activeModals.length === 0 &&
            this.navigator.activePriorityPopovers.length === 0;
  }
  
  clearGenericTimeout() {
    if (this.genricEventTimeoutId) {
      clearTimeout(this.genricEventTimeoutId);
      this.genricEventTimeoutId = null;
    }
  }

  private initializeTimeoutInterval(): void {
    try {
      const notificationTimeout =
        this.config.getConfig().FEATURE_NOTIFICATION_TIMEOUT;
      const initialTimeout = this.config.getConfig().FEATURE_INITIAL_TIMEOUT;
      const genricEventTimeout = this.config.getConfig().FEATURE_GENRIC_TIMEOUT;

      this.timeoutInterval = this.parseConfigValue(
        notificationTimeout,
        this.timeoutInterval
      );
      this.initialTimeout = this.parseConfigValue(
        initialTimeout,
        this.initialTimeout
      );
      this.genricEventTimeout = this.parseConfigValue(
        genricEventTimeout,
        this.genricEventTimeout
      );
    } catch (e) {
      console.error("Error Parsing Timeout Configurations:", e);
    }
  }

  private parseConfigValue(configValue: string, defaultValue: number): number {
    const parsedValue = Number(configValue);
    return !isNaN(parsedValue) && parsedValue > 0 ? parsedValue : defaultValue;
  }

  private handleGenericPopups(e) {
    const event = this.eventProcessor(e);
    if (!event) return;
    if (this.recentEvent) {
      this.hideNotification();
      if (this.eventHideTimeout) this.eventHideTimeout = null;
    }
    this.eventQueue.push(event);
    this.recentEvent = event;

    const isAutoHideEnabled =
      event.hideTimeout == undefined ? true : event.hideTimeout;
    const isAutoHideTimeout = event.hideTimeout ? event.hideTimeout : 10000;
    this.eventsService.publish("event:notification:show");
    this.genericPopupShown = true;

    if (isAutoHideEnabled) {
      this.eventHideTimeout = setTimeout(() => {
        this.hideNotification();
      }, isAutoHideTimeout);
    }
  }
  hideNotification() {
    this.eventsService.publish("event:notification:hide");
    this.genericPopupShown = false;
  }
  private getEventConfiguration() {
    if (this.eventConfig) return;
    let config;
    const defaultConfig = {
      LOW_BALANCE: {
        hideTimeout: 10000,
        actionComponent: "ShopPageComponent",
        title: "You're low on coins!",
        text: "We noticed that your balance is too low to place bets on most games. You may need to buy more coins to continue",
        testField: "customField2",
        actionText: "SHOP",
      },
      NEW_MESSAGE: {
        hideTimeout: 3000,
        actionComponent: "MessageAlertComponent",
        title: "New Message Received",
        message: "You have a new message in your inbox.",
      },
      CHARACTERLIMIT: {
        title: 25,
        text: 120,
        actionText: 10,
      },
      // IGNOREUNKNOWN:{

      // }
    };
    try {
      const featureConfig = this.config.getConfig().FEATURE_NOTIFICATION_CONFIG;
      if (featureConfig) {
        config = JSON.parse(featureConfig);
        return (this.eventConfig = config);
      } else {
        this.eventConfig = defaultConfig;
      }
    } catch (error) {
      this.eventConfig = defaultConfig;
    }
  }

  public get isSplashScreenFinished(): boolean {
    return this._isSplashScreenFinished;
  }
  public set isSplashScreenFinished(value: boolean) {
    this._isSplashScreenFinished = value;
    this.isSplashScreenFinished$.next(value);
  }

  public get isNotificationHalted(): boolean {
    return this._isNotificationHalted;
  }
  public set isNotificationHalted(value: boolean) {
    if (this._isNotificationHalted === value) {
      return;
    }
    this._isNotificationHalted = value;
    this.isNotificationHalted$.next(value);
  }
  private eventProcessor(event) {
    this.getEventConfiguration();

    const eventType = event.type;
    let newEvent = { ...event };

    const characterLimits = this.eventConfig?.CHARACTERLIMIT;

    if (this.eventConfig && this.eventConfig[eventType]) {
      const config = this.eventConfig[eventType];
      Object.keys(config).forEach((configKey) => {
        if (event.hasOwnProperty(configKey)) {
          newEvent[configKey] = event[configKey];
        } else {
          newEvent[configKey] = config[configKey];
        }

        if (characterLimits && characterLimits[configKey]) {
          const limit = characterLimits[configKey];
          if (newEvent[configKey] && newEvent[configKey].length > limit) {
            newEvent[configKey] = newEvent[configKey].substr(0, limit) + "...";
          }
        }
      });
    }

    if (
      this.eventConfig &&
      !this.eventConfig[eventType] &&
      this.eventConfig["IGNOREUNKNOWN"]
    ) {
      return null;
    }

    return newEvent;
  }

}
